import * as TYPES from './_store/types';

export async function asyncData(store) {
    const { ids, noFetch } = this;
    if (!noFetch) {
        return Promise.all([
            store[TYPES.FETCH_NBR_LIST]({
                ids,
            })
        ]);
    }
}
